import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Divider, Box, InputBase, Card, CardContent, createFilterOptions, CardMedia, Grid, Button, MenuItem, Select, Autocomplete, Typography, IconButton } from "@mui/material";
import { SelectData } from "../../../mock-data/services-data-mock";
import MapImage from "../../../assets/SVG/services/map.svg";
import NoResult from "../../../assets/common-images/svg/noresult.svg";
import { Search, Message } from "@mui/icons-material";
import { Miles } from "../../../mock-data/services-data-mock";
import { SearchOptions } from "../../../mock-data/services-data-mock";
import ApiClient from "helpers/ApiClient";
import { v4 as uuidv4 } from 'uuid';
import "../../../scss/common.scss";
import "../services.scss";
import { CardsApiLoader } from "component/pre-loader/pre-loader";


interface bookAppointmentForm {
  serviceName: any,
  setServiceName: any,
  setSelectedCard: any,
  setBookingService: any
  setFindCards: any
};
const Services = (props: bookAppointmentForm) => {
  const { serviceName, setServiceName, setBookingService, setSelectedCard, setFindCards } = props;
  const [option, setOption] = useState(serviceName);
  const [selectedOption, setSelectedOption] = useState("");
  const [mile, setMile] = useState("10");
  const [serviceData, setServicesData] = useState([])
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();
  type Options = { location: string };
  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option: Options) => option.location,
  });

  const params: any = useMemo(() => ({
    type: serviceName,
    address: '79.8,28.6',
    distance: mile === "Overall" ? "10" : mile,
    page: 1,
    limit: 10,
  }), [serviceName, mile])

  const getServicesData = async () => {
    try {
      setLoading(true)
      const query = '?' + new URLSearchParams(params).toString();
      const res = await ApiClient.get(`manage-services/find${query}`)
      setServicesData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getServicesData()
  }, [params])

  return (
    <>
      <Box
        className="services"
        sx={{
          minHeight: "80vh",
          borderRadius: "8px",
          background: "white",
          padding: "1rem",
          boxShadow: "-8px 8px 45px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Typography className="grey-color fs-20 fw-700"> Find  {serviceName}</Typography>
          <Select id="optionSelect" name="optionSelect" value={option} onChange={(e) => { setOption(e.target.value); setServiceName(e.target.value) }}
            sx={{ py: "0px", pl: "5px", pr: "12px", mb: "10px", width: { xs: "100%", sm: "auto" } }}>
            {SelectData.map((item) => (
              <MenuItem key={uuidv4()} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Divider />

        <Card square elevation={0} sx={{ display: "flex", mt: "40px", minHeight: { md: "60vh" } }}>
          <Grid container>
            <Grid item lg={4} className="bg-silver" sx={{ width: { xs: "100%", lg: "auto" } }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CardContent sx={{ flex: "1 0 auto" }}>
                  <Autocomplete
                    id="filter-demo"
                    options={SearchOptions}
                    getOptionLabel={(option) => option.location}
                    filterOptions={filterOptions}
                    onChange={(e, value) => (value !== null ? setSelectedOption(value!.location) : setSelectedOption(""))}
                    renderInput={(params) => (
                      <Box sx={{ position: "relative" }}>
                        <InputBase
                          value={selectedOption}
                          ref={params.InputProps.ref}
                          inputProps={params.inputProps}
                          onChange={(e) => setSelectedOption(e.target.value)}
                          className="custom-search"
                          placeholder="Search by location or zip code..."
                        />
                        <Search sx={{ color: "#6C6B6B", fontSize: "25px", position: "absolute", top: "25%", right: "15px" }} />
                      </Box>
                    )}
                  />
                </CardContent>
                <Box className="custom-scroll" sx={{ overflowY: "scroll", height: {sm:"50vh",xs:'100%'},px:{sm:2,xs:1} }}>
                  {!loading && (serviceData.map((item: any, i: number) => {
                    const placeholderImage = `https://ui-avatars.com/api/?rounded=true&name=${item?.firstName} ${item?.lastName}`;
                    let address = item?.companyDetails?.registered_office_address;
                    return (
                      <Card key={uuidv4()} sx={{mb: "20px", borderRadius: 2 }} variant="outlined">
                        <CardContent>
                          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row", lg: "column", xl: "row" }, justifyContent: "space-between", alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <Box>
                                {serviceName === 'Lawyers' &&
                                  <IconButton disableRipple sx={{ p: 0 }}>
                                    <img
                                      style={{ borderRadius: "50%", objectFit: "cover" }}
                                      width={40}
                                      height={40}
                                      src={item?.imageId ? item?.imageId : placeholderImage}
                                      alt={"user_profile"}
                                      onError={(e: any) => { e.target.src = placeholderImage }}
                                    />
                                  </IconButton>
                                }
                              </Box>
                              <Typography className="fs-18 fw-700 grey-color">
                                {serviceName === "Lawyers" ? `${item?.firstName} ${item?.lastName}`
                                  : `${item?.User?.firstName} ${item?.User?.lastName}`}
                              </Typography>
                              <Message sx={{ ml: "10px", color: "#7FB341", "&:hover": { cursor: "pointer" } }} onClick={() => navigate("/inbox")} />
                            </Box>
                            <Box sx={{ textAlign: "right", my: { xs: "10px", lg: "0" } }}>
                              <p className="fs-20 fw-700 secondary-color">{serviceName === 'Lawyers' && `£${item?.consultationFee}`}</p>
                            </Box>
                          </Box>
                          <Box sx={{ ml: "8px", mt: "10px" }} className="paragraph-padding">
                            <p className="fs-14 grey-color">
                              {(serviceName === "Lawyers" || serviceName === "Charging Stations") ? `${item?.buildingNumber??"-"} ${item?.street??"-"}, ${item?.town??"-"} ${item?.postCode??"-"}, ${item?.country??"-"}`
                                : `${address?.address_line_1??"-"}, 
                              ${address?.address_line_2??"-"}
                              ${address?.locality??"-"} 
                              ${address?.country??"-"}`}
                            </p>
                            <p className="fs-14 selected-field-color">
                              {serviceName === "Lawyers" ? item?.regulatoryFirm : item?.adminPhone}
                            </p>
                            <p className="fs-14 selected-field-color">
                              {serviceName !== "Lawyers" && `${item?.distance.toFixed(2)} miles away`}
                            </p>
                            <Button
                              variant="contained"
                              disableRipple
                              className="appointment-button"
                              onClick={() => { setBookingService('Book Appointment'); setSelectedCard(item) }}
                              sx={{
                                fontSize: { xs: "10px", md: "14px" },
                                boxShadow: "0",
                                "&:hover": {
                                  boxShadow: "0",
                                },
                              }}>
                              {serviceName === "Lawyers" ? "Book Appointment" : "Book Now"}
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>)
                  }))}
                  {loading ? <CardsApiLoader image /> : serviceData.length === 0 && <Box sx={{ textAlign: 'center' }}>
                    <img src={NoResult} alt='noresult' height={200} width={200} />
                    <p className="disabled-color">No {option} Found</p>
                  </Box>}
                </Box>
              </Box>
            </Grid>
            <Grid item lg={8} sx={{ width: { xs: "100%", lg: "auto" } }}>
              <Box sx={{ position: "relative" }}>
                <CardMedia sx={{ minHeight: { xs: "40vh", md: "60vh" } }} component="img" image={MapImage} alt="Live from space album cover" />
                <Select id="mileSelect" name="mileSelect" value={mile}
                  onChange={(event: any) => setMile(event.target.value)}
                  sx={{
                    position: "absolute", top: "20px", right: "20px",
                    backgroundColor: "white", pl: "4px", pr: "12px"
                  }}>
                  {Miles.map((item, i) => (
                    <MenuItem key={uuidv4()} value={item.value}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Grid>
            <Button disableRipple onClick={() => { setFindCards(false) }} sx={{ color: "black", mt: 3 }} >
              Back
            </Button>
          </Grid>
        </Card>
      </Box>

    </>
  );
};
export default Services;
